import { jsx } from "react/jsx-runtime";
import { Box } from "braid-design-system";
import { root } from "./ScreenReaderOnly.css.mjs";
const ScreenReaderOnly = ({ children }) => /* @__PURE__ */ jsx(Box, { className: root, children });
export {
  ScreenReaderOnly
};
